import React, { useEffect, useState } from "react";
import Textfield from "@atlaskit/textfield";
import { Flex, Flex1, Flex5 } from "../../../../../../common/style";
import Button from "@atlaskit/button/new";
import { useSelector } from "react-redux";
import DeleteIcon from "@atlaskit/icon/core/delete";

function CustomFieldInputRow({ field, body, update }) {
  const [value, setValue] = useState("");
  const fields = useSelector((state) => state.jira.fields);

  useEffect(() => {
    if (field && field.length > 1) {
      setValue(asText(field[1]));
    }
  }, [body, field]);

  const getFieldName = (fieldId) => {
    const result = fields.find((f) => f.id === fieldId);
    if (!result) return "";
    return (
      <>
        <b>{result.name} </b> [{result.id}]
      </>
    );
  };
  const onRemove = () => {
    delete body.fields[field[0]];
    update(JSON.parse(JSON.stringify(body)));
  };
  const onChangeFieldValue = (e) => {
    setValue(e.target.value);
    body.fields[field[0]] = asJSON(e.target.value);
    update(body);
  };

  const asJSON = (value) => {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  };
  const asText = (value) => {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return value;
    }
  };

  return (
    <>
      <Flex>
        <Flex5>
          {field && getFieldName(field[0])}
          <Textfield name="fieldExpression" isCompact={true} onChange={onChangeFieldValue} value={value} />
        </Flex5>
        <Flex1>
          <br />
          <Button iconBefore={DeleteIcon} appearance="subtle" onClick={onRemove}>
            Remove
          </Button>
        </Flex1>
      </Flex>
    </>
  );
}
export default CustomFieldInputRow;
